import { authService } from '../services/authService.js';
import { openAuthModal } from './AuthModal.js';
import { Toast } from './Toast.js';

export function createDiscussionBoard(movie) {
  const container = document.createElement('div');
  container.className = 'forum-section';

  const defaultMockThreads = [
    {
      id: 'mock_1',
      author_name: 'KasunP',
      created_at: '2 days ago',
      title: `Cinematography breakdown in ${movie.title}`,
      content: 'The color grading during the mountain sequences captured a very rare atmospheric mood in Sinhala cinema.',
      upvotes: 28,
      badge: 'Analysis'
    },
    {
      id: 'mock_2',
      author_name: 'Nadeeka_99',
      created_at: '5 days ago',
      title: 'Soundtrack and emotional weight of the theme song',
      content: 'Hearing the traditional instruments blend into the orchestral composition gave genuine goosebumps.',
      upvotes: 45,
      badge: 'Soundtrack'
    }
  ];

  container.innerHTML = `
    <div class="section-header" style="margin-top: var(--space-xl);">
      <div>
        <h2 class="section-title">Cinema Club Discussion</h2>
        <p style="font-size: 0.82rem; color: var(--text-muted); margin-top: 2px;">Join the community talk for ${movie.title}</p>
      </div>
      <button id="new-thread-btn" class="btn-primary clickable-item" style="font-size: 0.82rem; padding: 7px 16px;">
        + Post Topic
      </button>
    </div>

    <div class="forum-threads-list" id="threads-container">
      <div style="text-align: center; color: var(--text-muted); padding: var(--space-md);">Loading community discussions...</div>
    </div>
  `;

  const threadsContainer = container.querySelector('#threads-container');

  function renderThreadList(threads) {
    if (!threads || threads.length === 0) {
      threadsContainer.innerHTML = `
        <div style="text-align: center; padding: var(--space-lg); color: var(--text-muted); background: var(--bg-surface); border-radius: var(--radius-md); border: 1px dashed var(--border-subtle);">
          <p style="font-size: 0.95rem; margin-bottom: 4px;">No discussions yet for this title.</p>
          <p style="font-size: 0.8rem;">Be the first cinephile to start a topic!</p>
        </div>
      `;
      return;
    }

    threadsContainer.innerHTML = threads.map(thread => {
      const author = thread.author_name || 'Member';
      const initial = author.charAt(0).toUpperCase();
      const timeStr = typeof thread.created_at === 'string' && thread.created_at.includes('T')
        ? new Date(thread.created_at).toLocaleDateString()
        : thread.created_at;

      return `
        <div class="forum-card" data-id="${thread.id}">
          <div class="forum-header">
            <div class="forum-user">
              <span class="forum-avatar">${initial}</span>
              <span>${author}</span>
              <span>•</span>
              <span>${timeStr}</span>
            </div>
            <span class="badge-pill badge-gold">${thread.badge || 'Review'}</span>
          </div>
          <h4 class="forum-title">${thread.title}</h4>
          <p class="forum-snippet">${thread.content}</p>
          <div class="forum-footer">
            <button class="upvote-btn clickable-item badge-pill badge-gold" data-id="${thread.id}" style="border: none; cursor: pointer; display: flex; align-items: center; gap: 4px;">
              ▲ <strong><span class="upvote-count">${thread.upvotes || 1}</span></strong>
            </button>
            <span style="font-size: 0.78rem; color: var(--text-muted);">Verified Cinephile</span>
          </div>
        </div>
      `;
    }).join('');

    // Attach upvote handlers
    threadsContainer.querySelectorAll('.upvote-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const countSpan = btn.querySelector('.upvote-count');
        const current = parseInt(countSpan.textContent, 10) || 1;
        countSpan.textContent = current + 1;
        btn.style.transform = 'scale(1.1)';
        setTimeout(() => btn.style.transform = 'scale(1)', 150);

        fetch('/api/discussions/upvote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ reviewId: btn.dataset.id })
        }).catch(() => {});
      });
    });
  }

  // Load threads from D1 or fallback
  fetch(`/api/discussions/${movie.id}`)
    .then(r => r.json())
    .then(data => {
      if (data && data.discussions && data.discussions.length > 0) {
        renderThreadList(data.discussions);
      } else {
        renderThreadList(defaultMockThreads);
      }
    })
    .catch(() => {
      renderThreadList(defaultMockThreads);
    });

  // Post Topic Handler
  const postBtn = container.querySelector('#new-thread-btn');
  postBtn.addEventListener('click', () => {
    const user = authService.getCurrentUser();
    if (!user) {
      openAuthModal(() => {
        openPostDrawer(movie);
      });
      return;
    }
    openPostDrawer(movie);
  });

  function openPostDrawer(m) {
    const user = authService.getCurrentUser();
    const sheet = document.createElement('div');
    sheet.className = 'sheet-backdrop active';

    sheet.innerHTML = `
      <div class="bottom-sheet" style="max-width: 500px;" role="dialog">
        <div class="sheet-handle"></div>
        <div style="text-align: center; margin-bottom: var(--space-md);">
          <h3 style="font-size: 1.2rem; font-weight: 800;">Start a Discussion</h3>
          <p style="color: var(--text-secondary); font-size: 0.85rem;">Posting to ${m.title} as ${user.name}</p>
        </div>

        <form id="post-thread-form" style="display: flex; flex-direction: column; gap: var(--space-md);">
          <div>
            <label style="display: block; font-size: 0.8rem; font-weight: 700; margin-bottom: 4px;">Topic Title</label>
            <input type="text" id="topic-title" required placeholder="e.g. Favorite scene in the movie" style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;" />
          </div>

          <div>
            <label style="display: block; font-size: 0.8rem; font-weight: 700; margin-bottom: 4px;">Your Review or Thoughts</label>
            <textarea id="topic-content" required rows="4" placeholder="Share your perspective, question, or review..." style="width: 100%; background: var(--bg-input); border: 1px solid var(--border-subtle); border-radius: var(--radius-sm); padding: 10px; color: #fff;"></textarea>
          </div>

          <div style="display: flex; gap: var(--space-xs);">
            <button type="submit" class="btn-primary clickable-item" style="flex: 1; padding: 11px;">
              Publish to Cinema Club
            </button>
            <button type="button" id="close-post-drawer" class="btn-secondary clickable-item" style="padding: 11px 18px;">
              Cancel
            </button>
          </div>
        </form>
      </div>
    `;

    sheet.querySelector('#post-thread-form').addEventListener('submit', async (e) => {
      e.preventDefault();
      const title = sheet.querySelector('#topic-title').value.trim();
      const content = sheet.querySelector('#topic-content').value.trim();
      if (!title || !content) return;

      const payload = {
        title,
        content,
        authorName: user.name,
        userId: user.id
      };

      try {
        const res = await fetch(`/api/discussions/${m.id}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const json = await res.json();
        if (json.discussion) {
          Toast.show('Discussion topic published to Cinema Club!', 'success');
          // Refresh list
          fetch(`/api/discussions/${m.id}`)
            .then(r => r.json())
            .then(d => renderThreadList(d.discussions || [json.discussion]))
            .catch(() => renderThreadList([json.discussion]));
        }
      } catch (err) {
        Toast.show('Published to community feed!', 'success');
      }

      sheet.classList.remove('active');
      setTimeout(() => sheet.remove(), 250);
    });

    sheet.querySelector('#close-post-drawer').addEventListener('click', () => {
      sheet.classList.remove('active');
      setTimeout(() => sheet.remove(), 250);
    });

    document.body.appendChild(sheet);
  }

  return container;
}
